module.exports = __webpack_public_path__ + "img/seminar_seminar_header.d92f04a4.jpg";